<template>
  <div
    class="
      min-h-screen
      flex flex-col
      sm:justify-center
      items-center
      py-gr-7
      bg-primary-muted-50
      text-secondary-muted-700
    "
  >
    <div>
      <slot name="logo" />
    </div>

    <div :class="['panel', panelClasses]">
      <slot />
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      panelClasses: {
        type: String,
        default: 'mt-gr-6 sm:max-w-md container',
      },
    },
  };
</script>
